import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  uppercaseChar6lahngw3wvwg as uppercaseChar,
  isLetterOrDigit2kuxd9e198haf as isLetterOrDigit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { toString3o7ifthqydp6e as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { DirectlyDisplayableStatebtdfi3611j0b as DirectlyDisplayableState } from '../components/project/work/payApps/data.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DisplayableStateSemanticClass;
function DisplayableStateSemantic() {
  if (DisplayableStateSemanticClass === VOID) {
    class $ extends Semantic() {
      static mgt(state) {
        // Inline function 'kotlin.text.replaceFirstChar' call
        var this_0 = state.g90();
        var tmp;
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(this_0) > 0) {
          var it = charCodeAt(this_0, 0);
          var tmp0 = uppercaseChar(it);
          // Inline function 'kotlin.text.plus' call
          var other = substring(this_0, 1);
          tmp = toString(tmp0) + other;
        } else {
          tmp = this_0;
        }
        // Inline function 'kotlin.text.filter' call
        var tmp0_0 = tmp + state.h90();
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().d1();
        var inductionVariable = 0;
        var last = charSequenceLength(tmp0_0);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(tmp0_0, index);
            if (isLetterOrDigit(element)) {
              destination.xb(element);
            }
          }
           while (inductionVariable < last);
        var tmp$ret$6 = destination.toString();
        var $this = this.bd1('ds' + tmp$ret$6);
        $this.lgt_1 = state;
        return $this;
      }
      cd1(theme) {
        var tmp;
        var tmp_0 = this.lgt_1;
        if (isInterface(tmp_0, DirectlyDisplayableState())) {
          tmp = this.lgt_1.fg0();
        } else {
          tmp = Companion_getInstance().acz(this.lgt_1.h90());
        }
        var color = tmp;
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, color);
      }
      toString() {
        return 'DisplayableStateSemantic(state=' + toString_0(this.lgt_1) + ')';
      }
      hashCode() {
        return hashCode(this.lgt_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DisplayableStateSemantic()))
          return false;
        if (!equals(this.lgt_1, other.lgt_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DisplayableStateSemantic');
    DisplayableStateSemanticClass = $;
  }
  return DisplayableStateSemanticClass;
}
function LineItemStateSemantic(state) {
  return DisplayableStateSemantic().mgt(state);
}
function IncidentStateSemantic(state) {
  return DisplayableStateSemantic().mgt(state);
}
var ProjectStateSemanticClass;
function ProjectStateSemantic() {
  if (ProjectStateSemanticClass === VOID) {
    class $ extends Semantic() {
      static ch1(state) {
        var $this = this.bd1('prj' + toString_0(state));
        $this.ah1_1 = state;
        $this.bh1_1 = Companion_getInstance().acz($this.ah1_1.t9b_1);
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, VOID, theme.eb0_1.td4(VOID, VOID, true), VOID, VOID, VOID, VOID, this.bh1_1, VOID, this.bh1_1);
      }
      toString() {
        return 'ProjectStateSemantic(state=' + toString_0(this.ah1_1) + ')';
      }
      hashCode() {
        return this.ah1_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectStateSemantic()))
          return false;
        if (!this.ah1_1.equals(other.ah1_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ProjectStateSemantic');
    ProjectStateSemanticClass = $;
  }
  return ProjectStateSemanticClass;
}
var StrikeThroughSemanticClass;
function StrikeThroughSemantic() {
  if (StrikeThroughSemanticClass === VOID) {
    class $ extends Semantic() {
      static kjs() {
        StrikeThroughSemantic_instance = null;
        var $this = this.bd1('strk');
        StrikeThroughSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, VOID, theme.eb0_1.dd1(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
      }
      toString() {
        return 'StrikeThroughSemantic';
      }
      hashCode() {
        return 725332135;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StrikeThroughSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'StrikeThroughSemantic');
    StrikeThroughSemanticClass = $;
  }
  return StrikeThroughSemanticClass;
}
var StrikeThroughSemantic_instance;
function StrikeThroughSemantic_getInstance() {
  if (StrikeThroughSemantic_instance === VOID)
    StrikeThroughSemantic().kjs();
  return StrikeThroughSemantic_instance;
}
var GreyedOutSemanticClass;
function GreyedOutSemantic() {
  if (GreyedOutSemanticClass === VOID) {
    class $ extends Semantic() {
      static mjs() {
        GreyedOutSemantic_instance = null;
        var $this = this.bd1('greyd');
        GreyedOutSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().ffz_1.xg9_1, VOID, AppColors_getInstance().ffz_1.xg9_1);
      }
      toString() {
        return 'GreyedOutSemantic';
      }
      hashCode() {
        return 721510052;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GreyedOutSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'GreyedOutSemantic');
    GreyedOutSemanticClass = $;
  }
  return GreyedOutSemanticClass;
}
var GreyedOutSemantic_instance;
function GreyedOutSemantic_getInstance() {
  if (GreyedOutSemantic_instance === VOID)
    GreyedOutSemantic().mjs();
  return GreyedOutSemantic_instance;
}
//region block: exports
export {
  DisplayableStateSemantic as DisplayableStateSemantic2q119ycceacla,
  IncidentStateSemantic as IncidentStateSemanticqw5umh5a9l7i,
  LineItemStateSemantic as LineItemStateSemantic242xtb5m8w8mc,
  ProjectStateSemantic as ProjectStateSemanticzawrm52z9108,
  GreyedOutSemantic_getInstance as GreyedOutSemantic_getInstancexltt5xem3a07,
  StrikeThroughSemantic_getInstance as StrikeThroughSemantic_getInstance2noty866j55zj,
};
//endregion

//# sourceMappingURL=states.mjs.map
